export default __webpack_public_path__ + "static/media/google-play.fce37c01.png";